import React, { FC, ReactElement, useEffect, useState } from 'react';
import styled from 'styled-components';

import Set from '../../set/Set';
import './Tabs.scss';

export type tabsProps = {
  index: number | null;
  path: {
    slideIndex: number;
    comboIndex: number;
    setIndex: number | null;
    groupIndex: number | null;
    elementIndex: number | null;
  } | null;
  activePath: {
    slideIndex: number;
    comboIndex: number | null;
    setIndex: number | null;
    groupIndex: number | null;
    elementIndex: number | null;
  } | null;
  name: string;
  editorPlugins: any | null;
  settings: {
    horizontalAlignment: string;
    verticalAlignment: string;
    maxWidth: string;
    tabsItems: any;
    tabsLayout: string;
    tabsColor: string;
    tabsHoverColor: string;
    tabsBgColor: string;
    tabsBgHoverColor: string;
    tabsBorderColor: string;
    tabsBorderHoverColor: string;
    tabsBorderWidth: number;
    tabsBorderRadius: string;
    tabsFontSize: string;
    tabsPerRow: number;
    isShowTabsIcons: true;
    tabsAutoplay: false;
    tabsLoop: false;
    tabsSpeed: string;
    tabsDelay: number;
  };
  setsWidth: string;
  sets: any;
};

type tabsComboProps = {
  color: string;
  colorHover: string;
  bgColor: string;
  bgColorHover: string;
  borderWidth: number;
  borderRadius: string;
  borderColor: string;
  borderColorHover: string;
  fontSize: string;
  titleWidth: number | null;
  tabsPerRow: number;
};

const TabsCombo = styled.div<tabsComboProps>`
  &.tabsCombo {
    .tabsTitles {
      .innerWrapper {
        border: ${(props) => props.borderWidth || '1'}px solid
          ${(props) => props.borderColor || 'transparent'};
        ${(props) =>
          props.borderColor &&
          `
            border-color: ${props.borderColor !== 'none' ? props.borderColor : 'transparent'};
       `}
        ${(props) =>
          props.borderRadius &&
          `
            border-radius: ${props.borderRadius};
       `}
       ${(props) =>
          props.borderColorHover &&
          `
            &:hover {
              border-color: ${props.borderColorHover};
            }
       `};
        .titleItem {
          ${(props) =>
            props.titleWidth &&
            `
            width: ${props.titleWidth + '%'};
         `};
          .tabTitle {
            ${(props) =>
              props.fontSize &&
              `
            font-size: ${props.fontSize + 'px'};
         `};
            ${(props) =>
              props.borderWidth &&
              `
            border: ${props.borderWidth || '1'}px solid ${props.borderColor || 'transparent'};
         `};
            ${(props) =>
              props.borderRadius &&
              `
            border-radius: ${props.borderRadius};
         `};
            p {
              ${(props) =>
                props.fontSize &&
                `
                font-size: ${props.fontSize + 'px'};
             `};
            }
          }
        }
      }
      &.design-1 {
        .innerWrapper {
          border: 1px solid ${(props) => props.bgColor || props.borderColor};
          ${(props) =>
            props.borderWidth &&
            `
            border-width: ${props.borderWidth};
       `}
          ${(props) =>
            props.borderRadius &&
            `
             border-radius: ${props.borderRadius};
         `};
          .titleItem {
            ${(props) =>
              props.tabsPerRow &&
              `
             &:nth-child(${props.tabsPerRow}n) .tabTitle {
                border: none;
             }
           `};
            .tabTitle {
              ${(props) =>
                props.color &&
                `
                color: ${props.color};
             `};
              ${(props) =>
                props.colorHover &&
                `
                &.active, &:hover{
                    color: ${props.colorHover};
                }
             `};
              p {
                ${(props) =>
                  props.color &&
                  `
                    color: ${props.color};
                 `};
                ${(props) =>
                  props.colorHover &&
                  `
                    &.active, &:hover{
                        color: ${props.colorHover};
                    }
                 `};
              }
              &.active,
              &:hover {
                background: ${(props) => props.bgColorHover || 'var(--button-background-color)'};
                border-color: ${(props) => props.bgColorHover || 'var(--button-background-color)'};
              }
              ${(props) =>
                props.bgColor &&
                `
                background: ${props.bgColor};
                border-color: ${props.bgColorHover || props.bgColor};
             `};
              ${(props) =>
                props.borderWidth &&
                `
                border: ${props.borderWidth || '1'}px solid ${props.borderColor || 'transparent'};
             `};
              ${(props) =>
                props.borderRadius &&
                `
                border-radius: ${props.borderRadius};
             `};
            }
          }
        }
      }
      &.design-2 {
        .innerWrapper {
          ${(props) =>
            props.borderColor &&
            `
                border-color: ${props.borderColor};
         `}
          .titleItem {
            .tabTitle {
              ${(props) =>
                props.color &&
                `
                color: ${props.color};
                &.active {
                    color: ${props.color};
                    ${
                      props.colorHover &&
                      `
                        &:hover {
                            color: ${props.colorHover};
                        }
                    `
                    };
                    p {
                        color: ${props.color};
                        ${
                          props.colorHover &&
                          `
                        &:hover {
                            color: ${props.colorHover};
                        }
                    `
                        };
                    }
                    ${
                      props.bgColorHover &&
                      `
                        &:hover {
                            &:after {
                                background: ${props.bgColorHover};
                            }
                        }
                    `
                    }                                             
                }
             `};
            }
          }
        }
      }
      &.design-3 {
        .innerWrapper {
          ${(props) =>
            props.bgColor &&
            `
           background: ${props.bgColor};
       `}
          .titleItem {
            .tabTitle {
              ${(props) =>
                props.color &&
                `
                color: ${props.color};
                &.active, &:hover  {
                 color: ${props.colorHover};
                }
             `};
              p {
                ${(props) =>
                  props.color &&
                  `
                    color: ${props.color};
                    &.active, &:hover  {
                     color: ${props.colorHover};
                    }
                 `};
              }
              ${(props) =>
                props.bgColor &&
                `
                background: ${props.bgColor};
                &:hover, &.active {
                    background: ${props.bgColorHover || 'var(--button-background-color)'}
                }
            `}
            }
          }
        }
      }
      &.design-4 {
        .innerWrapper {
          .titleItem {
            .tabTitle {
              ${(props) =>
                props.color &&
                `
                color: ${props.color};
                &.active, &:hover  {
                 color: ${props.colorHover};
                }
             `};
              p {
                ${(props) =>
                  props.color &&
                  `
                color: ${props.color};
                &.active, &:hover  {
                 color: ${props.colorHover};
                }
             `};
              }
              ${(props) =>
                props.bgColor &&
                `
                background: ${props.bgColor};
                &:hover, &.active {
                    background: ${props.bgColorHover || 'var(--button-background-color)'}
                }
            `}
            }
          }
        }
      }
    }
  }
`;

const Tabs: FC<tabsProps> = ({ ...props }): ReactElement => {
  const [activeTab, setActiveTab] = useState(0);
  const [screenSize, setScreenSize] = useState<number>(window.innerWidth);

  useEffect(() => {
    if (props.settings.tabsAutoplay) {
      let delay = props.settings.tabsDelay * 1000;
      if (props.settings.tabsLoop) {
        let intervalId = setInterval(() => {
          autoPlayTabs();
        }, delay);
        return () => clearInterval(intervalId);
      } else {
        autoPlayTabs();
      }
    }
  }, [props.settings.tabsAutoplay, props.settings.tabsLoop]);

  useEffect(() => {
    setScreenSize(window.innerWidth);
  }, [window.innerWidth]);

  function autoPlayTabs() {
    let speed = getTabsSpeed();
    props.settings.tabsItems.titles.map((title: string, index: number) => {
      setTimeout(() => {
        setActiveTab(index);
      }, speed * index);
    });
  }

  function getTabsSpeed() {
    switch (props.settings.tabsSpeed) {
      case 'slow':
        return 15000;
      case 'medium':
        return 10000;
      case 'fast':
        return 5000;
      default:
        return 10000;
    }
  }

  function getPath(index: number) {
    if (!props.path) return null;
    let path = { ...props.path };
    path.setIndex = index;
    return path;
  }

  function changeActiveTab(index: number) {
    setActiveTab(index);
  }

  function setInstance(index: number, setData: any) {
    return (
      <Set
        key={index}
        {...setData}
        editorPlugins={props.editorPlugins}
        index={index}
        path={getPath(index)}
        isTab={true}
        disableDND={true}
        activeTab={index === activeTab}
        organizeGroupsForMobile={true}
      />
    );
  }

  function handleLayout() {
    // Temp solution
    if (screenSize < 1200 && props.settings.tabsLayout !== 'bottom') return 'layout-top';
    return props.settings.tabsLayout ? 'layout-' + props.settings.tabsLayout : 'layout-top';
  }

  function comboInstance() {
    return (
      <TabsCombo
        className={'combo tabsCombo tabElement ' + handleLayout()}
        color={props.settings.tabsColor}
        colorHover={props.settings.tabsHoverColor}
        bgColor={props.settings.tabsBgColor}
        bgColorHover={props.settings.tabsBgHoverColor}
        borderWidth={props.settings.tabsBorderWidth}
        borderRadius={props.settings.tabsBorderRadius}
        borderColor={props.settings.tabsBorderColor}
        borderColorHover={props.settings.tabsBorderHoverColor}
        fontSize={props.settings.tabsFontSize}
        titleWidth={getTitleWidth()}
        tabsPerRow={props.settings.tabsPerRow}>
        {props.settings.tabsLayout !== 'bottom' && tabsTitles()}
        {props.sets.map((set: any, index: number) => {
          return setInstance(index, set);
        })}
        {props.settings.tabsLayout === 'bottom' && tabsTitles()}
      </TabsCombo>
    );
  }

  function tabsTitles() {
    if (
      !props.settings.tabsItems ||
      !props.settings.tabsItems.titles ||
      !props.settings.tabsItems.titles.length
    )
      return;
    return (
      <div className={'tabsTitles tabElement ' + props.settings.tabsItems?.design}>
        <div className={'innerWrapper tabElement'}>
          {props.settings.tabsItems.titles.map((item: any, index: number) => {
            return (
              <div key={index} className={'titleItem tabElement'}>
                <div
                  className={
                    'tabElement tabTitle ' + (item.setIndex === activeTab ? 'active ' : '')
                  }
                  onClick={() => changeActiveTab(item.setIndex)}>
                  {props.settings.isShowTabsIcons && (
                    <span className="tabElement icon">
                      <div className="material-icons">{item.icon}</div>
                    </span>
                  )}
                  <span>{item.name}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  function getTitleWidth() {
    if (!props.settings.tabsPerRow) return null;
    return 100 / props.settings.tabsPerRow;
  }

  if (props.editorPlugins) {
    const TabsEditor = require('./TabsEditor').default;
    return (
      <TabsEditor
        {...props}
        activeTab={activeTab}
        setInstance={setInstance}
        changeActiveTab={changeActiveTab}
        comboInstance={comboInstance}
        disableDND={true}
      />
    );
  } else {
    return comboInstance();
  }
};
export default Tabs;
